

.app {
    display: flex;
    align-items: center;
    justify-content: center;
}